import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  IBusinessInfo,
  IBusinessProfile,
} from '@g99-product-web-ui/shared-interface-lib';
import { LOCAL_STORAGE_KEYS } from '@g99-product-web-ui/shared-util-lib';

import { LocalStorageService } from './localStorage.service';

@Injectable({
  providedIn: 'root',
})
export class TenantService {
  private _tenantId = '';
  private _fId = '';
  private _userId = '';
  private _token = '';
  private _path = '';
  private _clinicId = '';

  constructor(
    private readonly _route: ActivatedRoute,
    private readonly _localStorageService: LocalStorageService
  ) {
    this._getTenantIdFromUrl();
  }

  public _attachTenantId(headers: HttpHeaders, attach: boolean): HttpHeaders {
    if (attach) {
      const tenantId = this.getBusinessId();
      headers = headers.set('X-TenantID', String(tenantId)); // Add tenantId to the headers
    }
    return headers; // Return the modified headers
  }

  public getTenantId(): string {
    return this._tenantId;
  }

  public getFId(): string {
    return this._fId;
  }

  public getUserId(): string {
    return this._userId;
  }

  public getToken(): string {
    return this._token;
  }

  public getPath(): string {
    return this._path;
  }

  public getClinicId(): string {
    return this._clinicId;
  }

  public getBusinessId(): string {
    const businessInfo = this._localStorageService.readItem(
      LOCAL_STORAGE_KEYS.BUSINESS_INFO
    ) as IBusinessInfo;

    return businessInfo?.id || '';
  }

  public getBusinessInfo(): IBusinessProfile {
    const businessInfo =
      this._localStorageService.readItem(LOCAL_STORAGE_KEYS.BUSINESS_INFO) ||
      {};

    return businessInfo as IBusinessProfile;
  }

  public getNotificationEmail(): string {
    const businessInfoString = localStorage.getItem('businessInfo');
    if (businessInfoString) {
      const businessInfo = JSON.parse(businessInfoString); // Parse the JSON string
      return businessInfo.notificationEmail; // Return businessId or default value
    }

    return ''; // Return default if not found
  }

  private _getTenantIdFromUrl() {
    this._route.queryParams.subscribe((params) => {
      if (params['bid']) {
        this._tenantId = params['bid'];
      }
      if (params['fid']) {
        this._fId = params['fid'];
      }
      if (params['userId']) {
        this._userId = params['userId'];
      }
      if (params['token']) {
        this._token = params['token'];
      }
      if (params['path']) {
        this._path = params['path'];
      }
      if (params['clinicId']) {
        this._clinicId = params['clinicId'];
      }
    });
  }
}
